import React, { useState } from "react";
import "./Content.css";
import {allTrans, yao_trans} from '../datas/Trans'

const IntroContent = ({clickFunc}) => {
  return (
    <>
      <button className="bg-gray-700 w-60 my-5 py-3 text-white font-bold text-xl rounded-2xl" onClick={clickFunc}>
        开始占卜
      </button>
      <ul className="text-justify">
        <li className="leading-8 py-2">
          <p>一事不二問。〔也不可以同一件事用不同問法重覆問，這是褻瀆〕</p>
        </li>
        <li className="leading-8 py-2">
          <p>
            重要事情請先齊戒沐浴〔或可於沐浴後〕；平時問卜，如廁之後請先洗手，並稍候再卜
          </p>
        </li>
        <li className="leading-8 py-2">
          <p>誠心冥想你的問題，心唸本人某某某，何事問卦...。</p>
        </li>
        <li className="leading-8 py-2">
          <p>
            若問某事吉凶可如此提問：所問何事，弟子欲做何選擇 /
            決定，想問吉凶....
          </p>
        </li>
        <li className="leading-8 py-2">
          <p>
            卜卦是與自己以及天地的交流對話，不是要讓人迷信、推卸責任。卜問者要有理性及自我負責的心態，不要期待它可以告訴你所有未知之事，卜卦不準是常有的事。
          </p>
        </li>
      </ul>
    </>
  );
};

const ResultContent = ({tran}) => {

  return (
    <>
      <img src={process.env.PUBLIC_URL+'/'+tran['imgPath']} alt="" className="w-28 py-5"/>
      <h2 className="font-bold text-3xl py-3">{tran['name']}</h2>
      <p className="leading-10">{tran['title']}</p>
      <BlockContent title="最近运程" content={tran['head']} />
      <BlockContent title="卦文解读" content={tran['content']} />
    </>
  );
};

const BlockContent = ({ title, content }) => {

  const paragraphs = content.split('\n').filter(p=>p.length>0).map(p => {
    return (
      <p className="py-3 text-justify">{p.trim()}</p>
    )
  })


  return (
    <div className="py-3">
      <h2 className="text-2xl font-black ">{title}</h2>
      {paragraphs}
    </div>
  );
};

const Container = ({result, setResult}) => {
  
  const [tran, setTran] = useState(allTrans[0])


  const divi = () => {
    let randIdx = 0
    for(let i=0;i<6;i++) {
      randIdx += parseInt(parseInt(Math.random()*2) * Math.pow(2,i))
    }
    randIdx = yao_trans[randIdx]

    setTran(allTrans[randIdx])
    setResult(true)    
  }


  return (
    <div className="flex flex-col justify-center items-center mx-auto w-4/5 py-3 pb-12">
      {result?  <ResultContent tran={tran}/> : <IntroContent clickFunc={divi}/>}
      
     
    </div>
  );
};

export default Container;
